// extracted by mini-css-extract-plugin
module.exports = {"content":"modalreset_content__3TE5A","label_forget":"modalreset_label_forget__2NYbx","form_forget":"modalreset_form_forget__14xZz"};